// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3sLaT","footer":"ChangeClinic_footer__hiTMP"};